<template>
  <div
    v-if="tags.length"
    class="v2-segment-tags"
    :class="inline ? 'v2-segment-tags--inline' : 'v2-segment-tags--compact'"
  >
    <span
      v-for="tag in tags"
      :key="tag"
      class="v2-segment-tags__tag"
      :title="`${tag} for your account`"
    >
      {{ tag }}
    </span>
  </div>
</template>

<script>
import { getSegmentTags } from '@/views/apps/checkout/cart-products-utils'

/**
 * KP-4350: informational per-style tags (e.g. "MCA") a brand sets inside a
 * segmentation, shown as chips. The backend only sends them to retailers in
 * that segment; a retailer in several segments gets every segment's tags.
 * They are shown alongside the key-styles badge and never replace it.
 */
export default {
  name: 'V2SegmentTags',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tags() {
      return getSegmentTags(this.product)
    },
  },
}
</script>

<style lang="scss" scoped>
// Rounded "chip" tags (white, light border, dark text). Fallback colours are
// used on V1 pages, which do not define the v2 tokens.
.v2-segment-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  &__tag {
    display: inline-flex;
    align-items: center;
    background: var(--v2-background, #fff);
    color: #2e2a4f;
    border: 1px solid #dcdce4;
    border-radius: 999px;
    padding: 4px 12px;
    font-size: 0.8125rem;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  // Smaller chips on the product card, under the style code.
  &--compact &__tag {
    padding: 2px 8px;
    font-size: 0.6875rem;
  }
}
</style>
